import { useMediaQuery } from "react-responsive";

const useIsBigDesktop = () => {
  const isBigScreen = useMediaQuery({ query: "(min-width: 1536px)" });
  return isBigScreen;
};

export default useIsBigDesktop;
